export enum TokenEnum {
  ETH = 'ETH',
  USDT = 'USDT',
  DAI = 'DAI',
  OZUSD = 'OZUSD',
}
